var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"300px"}},[_c('canvas',{attrs:{"id":"twelve-month-chart"}})])
}]

export { render, staticRenderFns }